import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for tooltip style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiTooltipStyle = (theme: Theme): ThemeStyle => {
  return {
    tooltip: {
      padding: '11px 16px',
      fontSize: 14,
      fontWeight: 'normal',
      lineHeight: '18px',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      minHeight: 40,
      maxWidth: 500,
    },

    arrow: {
      color: theme.palette.common.black,
    },
  };
};
